import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import LogRocket from 'logrocket';

import { api, apiReducer, apiMiddleware } from './rtk-query/api';

import appReducer from './slices/app-state/app-state.toolkit-slice';
import userPermissionsReducer from './slices/user-permissions-state/user-permissions-state.toolkit-slice';
import createPosition from './slices/create-position-state/create-position-state.toolkit-slice';
import onboardingReducer from './slices/onboarding-state/onboarding-state.toolkit-slice';
import matchReducer from './slices/match-state/match-state.toolkit-slice';
import outreachReducer from './slices/outreach-state/outreach-state.toolkit-slice';

import { errorMiddleware } from './middlewares/error.middleware';
import { appVersionMiddleware } from './middlewares/app-version.middleware';

const rootReducer = combineReducers({
  appReducer,
  createPosition,
  matchReducer,
  onboardingReducer,
  outreachReducer,
  userPermissionsReducer,
  [api.reducerPath]: apiReducer,
});

const persistedReducer = persistReducer({
  key: 'root',
  storage,
  whitelist: ['onboardingReducer'],
}, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    apiMiddleware,
    appVersionMiddleware,
    errorMiddleware,
    LogRocket.reduxMiddleware(),
  ],
});

setupListeners(store.dispatch);

export type RootReducerState = ReturnType<typeof store.getState>

export const persistor = persistStore(store);
